import { makeDataSelector, makeIsFetchingSelector } from 'utils/redux-utils'
import { find, flow, get } from 'lodash/fp'
import { createSelector } from 'reselect'

import { AVAILABLE_FILTERS_REDUCER_NAME } from 'components/Filters/consts'
import { PRODUCTS_REDUCER_NAME } from '../consts'

export const selectAvailableFiltersData = makeDataSelector([
  PRODUCTS_REDUCER_NAME,
  AVAILABLE_FILTERS_REDUCER_NAME,
])

export const isAvailableFiltersFetching = makeIsFetchingSelector([
  PRODUCTS_REDUCER_NAME,
  AVAILABLE_FILTERS_REDUCER_NAME,
])

export const filterCategoriesSelector = createSelector(
  selectAvailableFiltersData,
  flow(
    find(filter => filter.filterField === 'filter.category_tree'),
    get('items'),
  ),
)
